/* Google Analytics 4 — standalone, no dependencies.
 *
 * Loaded by the marketing pages via src/partials/analytics.html and by
 * index.html directly. The measurement ID lives here for every page that
 * loads this file, so turning GA4 on or off is a one-line change. app.html is
 * the exception: the app shell does not load this file and configures GA4 in
 * its own inline tag, so that ID has to be changed alongside this one.
 *
 * Design constraints (they mirror track.js — read that file too):
 *   - Inert until configured. With MEASUREMENT_ID empty this script does
 *     nothing at all: no network, no cookies, no globals.
 *   - Skip localhost, honour DNT, same as our first-party tracker.
 *   - Cookieless by default. Consent Mode's `analytics_storage` is "denied"
 *     before the first config call, so GA4 reports page views and referrers
 *     without writing a cookie and without needing a consent banner.
 *
 *     "Before the first config call" is the whole of it, and it is not the
 *     same as "before this file's config call". gtag reads the defaults as a
 *     tag initialises and ignores a default that arrives later. index.html and
 *     app.html carry an inline Google Ads tag that configures in <head>, long
 *     before this deferred file runs, so on those two pages the denial pushed
 *     from here landed after the fact and did nothing. They now push it
 *     themselves, ahead of their own config, and set the flag this file checks
 *     below. Fixed 2026-09-10; the ordering had been wrong since the tag
 *     shipped.
 *
 *     We deliberately do NOT set `ad_storage` / `ad_personalization` here.
 *     Consent defaults are global to the gtag dataLayer, and index.html
 *     already runs the Google Ads conversion tag (AW-18167893742) that our
 *     live campaigns depend on — denying ad storage from this file would
 *     silently degrade those conversions. Ads keeps its current behaviour;
 *     this file only constrains GA4.
 *
 *     If you later add a cookie consent banner and want full GA4 (cross-session
 *     users, demographics), have the banner call:
 *         gtag('consent', 'update', { analytics_storage: 'granted' });
 *     on accept. Until then, cookieless is the correct default under UK PECR.
 */
(function () {
  "use strict";

  // ── The one line to change. Paste the "G-XXXXXXXXXX" measurement ID from
  //    Google Analytics → Admin → Data streams → your web stream. ──────────
  var MEASUREMENT_ID = "G-NZ57WLGFW3";

  if (!MEASUREMENT_ID) return; // Not configured yet — do nothing.

  try {
    if (navigator.doNotTrack === "1" || window.doNotTrack === "1" || navigator.msDoNotTrack === "1") {
      return;
    }
  } catch {}

  var host = location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return;

  // gtag's queue must exist before anything pushes to it. index.html may have
  // already created both for the Ads tag — reuse them rather than clobbering.
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  if (typeof window.gtag !== "function") window.gtag = gtag;

  // Already pushed by an inline tag that had to configure before us (see the
  // header). Everywhere else this file is the first thing to touch gtag, so
  // here is before the first config and this is the only push there is.
  if (!window.sendinvoConsentDefaultSet) {
    gtag("consent", "default", { analytics_storage: "denied" });
    window.sendinvoConsentDefaultSet = true;
  }

  var s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + encodeURIComponent(MEASUREMENT_ID);
  document.head.appendChild(s);

  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID);
})();
